import React from 'react'
import { Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import { ROUTE_PATHS } from 'router/routes'

const UpgamingSportPage = React.lazy(() => import('pages/UpgamingSportPage/UpgamingSportPage'))

export class UpgamingSportModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.UPGAMING_SPORT_PAGE} path={ROUTE_PATHS.UPGAMING_SPORT_PAGE} exact>
        <QueryParamProvider ReactRouterRoute={Route}>
          <UpgamingSportPage />
        </QueryParamProvider>
      </Route>
    )
  }
}
